import api from '../config/api';

function unwrapError(error, fallback) {
  return {
    success: false,
    error: error.response?.data?.error || fallback,
    details: error.response?.data?.details,
  };
}

const ssomaService = {
  async fichas(empresaId, q = '') {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/fichas`, { params: q ? { q } : {} });
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar fichas SSOMA');
    }
  },

  async obtenerTallas(empresaId, empleadoId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/fichas/${empleadoId}/tallas`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar las tallas SSOMA');
    }
  },

  async guardarTallas(empresaId, empleadoId, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/fichas/${empleadoId}/tallas`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar las tallas SSOMA');
    }
  },

  async ficha(empresaId, empleadoId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/fichas/${empleadoId}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar la ficha SSOMA');
    }
  },

  async alertasDashboard(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/alertas-dashboard`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar alertas SSOMA');
    }
  },

  async notificaciones(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/notificaciones`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar notificaciones SSOMA');
    }
  },

  async marcarNotificacionLeida(empresaId, id) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/notificaciones/${id}/leer`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al marcar la notificación');
    }
  },

  async marcarNotificacionesLeidas(empresaId) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/notificaciones/leer-todas`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al marcar las notificaciones');
    }
  },

  async documentos(empresaId, params = {}) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/documentos`, { params });
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al listar documentos');
    }
  },

  async subirDocumento(empresaId, { tipo, archivo, empleadoId, titulo, fechaDocumento, fechaVencimiento, accidenteId, eppEntregaId, sctrId, emoId, asistenciaId, inspeccionId, iperId, empleados }) {
    try {
      const formData = new FormData();
      formData.append('tipo', tipo);
      formData.append('archivo', archivo);
      if (empleadoId) formData.append('empleado_id', empleadoId);
      if (titulo) formData.append('titulo', titulo);
      if (fechaDocumento) formData.append('fecha_documento', fechaDocumento);
      if (fechaVencimiento) formData.append('fecha_vencimiento', fechaVencimiento);
      if (accidenteId) formData.append('accidente_id', accidenteId);
      if (eppEntregaId) formData.append('epp_entrega_id', eppEntregaId);
      if (sctrId) formData.append('sctr_id', sctrId);
      if (emoId) formData.append('emo_id', emoId);
      if (asistenciaId) formData.append('asistencia_id', asistenciaId);
      if (inspeccionId) formData.append('inspeccion_id', inspeccionId);
      if (iperId) formData.append('iper_id', iperId);
      (empleados || []).forEach((id) => formData.append('empleados[]', id));

      const response = await api.post(`/ssoma/empresa/${empresaId}/documentos`, formData, {
        headers: { 'Content-Type': undefined },
        transformRequest: [(data, headers) => {
          if (headers && typeof headers === 'object') {
            delete headers['Content-Type'];
          }
          return data;
        }],
      });
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al subir documento');
    }
  },

  descargarDocumentoUrl(empresaId, documentoId) {
    return `/ssoma/empresa/${empresaId}/documentos/${documentoId}/descargar`;
  },

  async descargarDocumento(empresaId, documentoId, nombre) {
    const response = await api.get(this.descargarDocumentoUrl(empresaId, documentoId), {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombre || 'documento-ssoma');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async eliminarDocumento(empresaId, documentoId) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/documentos/${documentoId}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar documento');
    }
  },

  async guardarSctr(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/sctr`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar SCTR');
    }
  },

  async guardarSctrMasivo(empresaId, { tipo, aseguradora, numero, fecha_inicio, fecha_vencimiento, archivo, empleadoIds }) {
    try {
      const formData = new FormData();
      formData.append('tipo', tipo || 'ambos');
      if (aseguradora) formData.append('aseguradora', aseguradora);
      if (numero) formData.append('numero', numero);
      if (fecha_inicio) formData.append('fecha_inicio', fecha_inicio);
      formData.append('fecha_vencimiento', fecha_vencimiento);
      formData.append('archivo', archivo);
      (empleadoIds || []).forEach((id) => formData.append('empleado_ids[]', id));

      const response = await api.post(`/ssoma/empresa/${empresaId}/sctr/masivo`, formData, {
        headers: { 'Content-Type': undefined },
        transformRequest: [(data, headers) => {
          if (headers && typeof headers === 'object') {
            delete headers['Content-Type'];
          }
          return data;
        }],
      });
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar SCTR masivo');
    }
  },

  async actualizarSctr(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/sctr/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar SCTR');
    }
  },

  async guardarEmo(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/emos`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar EMO');
    }
  },

  async eliminarSctr(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/sctr/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar SCTR');
    }
  },

  async actualizarEmo(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/emos/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar EMO');
    }
  },

  async eliminarEmo(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/emos/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar EMO');
    }
  },

  async actualizarEppEntrega(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/epp/entregas/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar el registro EPP');
    }
  },

  async eliminarEppEntrega(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/epp/entregas/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar el registro EPP');
    }
  },

  async actualizarCapacitacion(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/capacitaciones/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar la capacitación');
    }
  },

  async eliminarCapacitacion(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/capacitaciones/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar la capacitación');
    }
  },

  async epp(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/epp`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar EPP');
    }
  },

  async guardarEppCatalogo(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/epp/catalogo`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar catálogo EPP');
    }
  },

  async actualizarEppCatalogo(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/epp/catalogo/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar el EPP');
    }
  },

  async eliminarEppCatalogo(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/epp/catalogo/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar el EPP');
    }
  },

  async guardarEppMovimiento(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/epp/movimientos`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al registrar movimiento EPP');
    }
  },

  async guardarEppEntrega(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/epp/entregas`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al registrar la entrega de EPP');
    }
  },

  async cursos(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/cursos`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar capacitaciones');
    }
  },

  async guardarCurso(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/cursos`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar curso');
    }
  },

  async guardarSesion(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/sesiones`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar sesión');
    }
  },

  async accidentes(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/accidentes`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar accidentes');
    }
  },

  async verAccidente(empresaId, id) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/accidentes/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar el accidente');
    }
  },

  async guardarAccidente(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/accidentes`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar accidente');
    }
  },

  async actualizarAccidente(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/accidentes/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar accidente');
    }
  },

  async guardarAccionAccidente(empresaId, accidenteId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/accidentes/${accidenteId}/acciones`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar acción');
    }
  },

  async inspecciones(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/inspecciones`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar inspecciones');
    }
  },

  async guardarInspeccion(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/inspecciones`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar inspección');
    }
  },

  async actualizarInspeccion(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/inspecciones/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar la inspección');
    }
  },

  async eliminarInspeccion(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/inspecciones/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar la inspección');
    }
  },

  async actualizarHallazgo(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/hallazgos/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar hallazgo');
    }
  },

  async iper(empresaId) {
    try {
      const response = await api.get(`/ssoma/empresa/${empresaId}/iper`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al cargar IPER');
    }
  },

  async guardarIper(empresaId, payload) {
    try {
      const response = await api.post(`/ssoma/empresa/${empresaId}/iper`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al guardar IPER');
    }
  },

  async actualizarIper(empresaId, id, payload) {
    try {
      const response = await api.put(`/ssoma/empresa/${empresaId}/iper/${id}`, payload);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al actualizar la matriz IPER');
    }
  },

  async eliminarIper(empresaId, id) {
    try {
      const response = await api.delete(`/ssoma/empresa/${empresaId}/iper/${id}`);
      return response.data;
    } catch (error) {
      return unwrapError(error, 'Error al eliminar la matriz IPER');
    }
  },
};

export default ssomaService;
